import {
  ESRIMapOptions,
  GoogleMapOptions,
} from '@rsos/components/capstone/common/Map/types';
import { ESRI, GOOGLE } from '@rsos/maps/constants/mapProviders';
import {
  EmergencyCallLocation,
  EmergencyCallSecondaryLocation,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';

/**
 * Check if the map is centered on a given location.
 * @param location - The location to check against the map center
 * @param mapOptions - The map to use for getting the center coordinates
 * @param tolerance  - How much difference to accept as centered
 * @returns bool
 */
export const isLocationCentered = (
  location: EmergencyCallLocation | EmergencyCallSecondaryLocation,
  mapOptions: ESRIMapOptions | GoogleMapOptions,
  tolerance = 0.000000000001,
) => {
  let mapLatitude: number | undefined;
  let mapLongitude: number | undefined;

  if (mapOptions.mapProvider === GOOGLE && mapOptions.mapInstance) {
    const mapCenter = mapOptions.mapInstance.getCenter();
    mapLatitude = mapCenter?.lat();
    mapLongitude = mapCenter?.lng();
  } else if (mapOptions.mapProvider === ESRI) {
    mapLatitude = mapOptions.mapInstance.view?.center.latitude;
    mapLongitude = mapOptions.mapInstance.view?.center.longitude;
  }

  if (!mapLatitude || !mapLongitude) {
    throw new Error('Could not get map center coordinates.');
  }

  return (
    Math.abs(mapLatitude - location.latitude) < tolerance ||
    Math.abs(mapLongitude - location.longitude) < tolerance
  );
};
